import { render, staticRenderFns } from "./CopySubgroup.vue?vue&type=template&id=d52c42e0"
import script from "./CopySubgroup.vue?vue&type=script&lang=js"
export * from "./CopySubgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports